export const MobileBreakpoint = {
  Max1439: '(max-width:1439px)',
  Max1023: '(max-width:1023px)',
  Max767: '(max-width:767px)',
  Min768: '(min-width:768px)',
};

export const isMobile = function(breakpoint) {
  return window.matchMedia(breakpoint).matches;
};
